import type { Principal } from '@/models/principal';

/**
 * "Gesperrt" (deactivated by support) as opposed to "abgelehnt" (rejected by the desired partner
 * lab). Fail-closed: `DISABLED` without an explicit `partnerLabRejected === true` counts as
 * gesperrt. Single place in the SPA for this distinction (LoginForm, RequireAccountEnabled).
 */
export function isOrganisationGesperrt(principal: Principal | null): boolean {
  return principal?.organizationState === 'DISABLED' && principal.partnerLabRejected !== true;
}
